import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/kings.webp'


const _withScopeId = n => (_pushScopeId("data-v-a7061c14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Reyes magos",
  src: _imports_0,
  style: {"width":"25%","height":"25%"}
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "main mt-2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createTextVNode("Hola "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"25px"} }, "😀")
], -1))
const _hoisted_6 = { style: {"color":"#693cd2"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"25px"} }, "😲", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Aquí podrás mandarles tu carta", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createTextVNode("Sólo pide ayuda a mamá o papá para que te registren y... ¡Listo a recibir muchos "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"25px"} }, "🎁"),
  /*#__PURE__*/_createTextVNode("!")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "d-grid gap-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "main mt-2"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "¡Hoy es día de reyes!", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Espero que recibas muchos "),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"25px"} }, "🎁")
], -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (!_ctx.isToday)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", null, [
            _createTextVNode("Faltan "),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.countDownText), 1),
            _createTextVNode(" para que lleguen los reyes magos "),
            _hoisted_7
          ]),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary btn-lg",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)))
            }, "Registrar")
          ]),
          _hoisted_12
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
  ]))
}